export const TonIcon = ({ className }: { className?: string }) => {
  return <img className={`${className}`} src="/assets/ton.svg" alt="Ton icon" />;
};
